// ImporterExtension.jsx
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
// import "./ImporterExtension.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faShieldAlt, 
  faLock, 
  faUserShield, 
  faCheckCircle,
  faExclamationTriangle,
  faEnvelope
} from "@fortawesome/free-solid-svg-icons";

function ImporterExtension() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  return (
    <div className="importer-page">
      <div className="importer-container">
        {/* Header Section */}
        <section className="importer-header" data-aos="fade-down">
          <div className="header-icon">
            <FontAwesomeIcon icon={faShieldAlt} />
          </div>
          <h1>Privacy Information for Extension Verification</h1>
          <h2>Extension Name: DLMS Web Importer</h2>
        </section>

        {/* Data Collection Section */}
        <section className="info-section" data-aos="fade-up">
          <div className="section-header">
            <FontAwesomeIcon icon={faUserShield} className="section-icon" />
            <h3>Data Collection & Usage</h3>
          </div>

          <div className="info-card" data-aos="fade-right">
            <h4><FontAwesomeIcon icon={faCheckCircle} /> What We Extract:</h4>
            <ul>
              <li>Research paper metadata (title, authors, journal, publication date, identifiers like DOI, arXiv ID, PMID)</li>
              <li>Website URLs where papers are found</li>
              <li>PDF links when available</li>
            </ul>
          </div>

          <div className="info-card" data-aos="fade-left">
            <h4><FontAwesomeIcon icon={faCheckCircle} /> What We Store Locally:</h4>
            <ul>
              <li>User authentication tokens (encrypted)</li>
              <li>User preferences (saved locally in browser storage)</li>
              <li>Paper metadata temporarily during import process</li>
            </ul>
          </div>

          <div className="info-card" data-aos="fade-right">
            <h4><FontAwesomeIcon icon={faCheckCircle} /> What We Send to Our Servers:</h4>
            <ul>
              <li>Authentication requests (OAuth 2.0 flow)</li>
              <li>Paper metadata being added to user's library</li>
              <li>No browsing history or personal data</li>
            </ul>
          </div>
        </section>

        {/* User Data Protection */}
        <section className="info-section" data-aos="fade-up">
          <div className="section-header">
            <FontAwesomeIcon icon={faLock} className="section-icon" />
            <h3>User Data Protection</h3>
          </div>

          <div className="protection-grid">
            <div className="protection-card" data-aos="zoom-in" data-aos-delay="100">
              <div className="card-icon">
                <FontAwesomeIcon icon={faLock} />
              </div>
              <p>All authentication tokens encrypted in browser storage</p>
            </div>
            <div className="protection-card" data-aos="zoom-in" data-aos-delay="200">
              <div className="card-icon">
                <FontAwesomeIcon icon={faShieldAlt} />
              </div>
              <p>No personal browsing history collected</p>
            </div>
            <div className="protection-card" data-aos="zoom-in" data-aos-delay="300">
              <div className="card-icon">
                <FontAwesomeIcon icon={faCheckCircle} />
              </div>
              <p>Data transmitted only over HTTPS</p>
            </div>
            <div className="protection-card" data-aos="zoom-in" data-aos-delay="400">
              <div className="card-icon">
                <FontAwesomeIcon icon={faUserShield} />
              </div>
              <p>Users can fully delete all data via extension logout</p>
            </div>
          </div>
        </section>

        {/* Permissions Justification */}
        <section className="info-section" data-aos="fade-up">
          <div className="section-header">
            <FontAwesomeIcon icon={faExclamationTriangle} className="section-icon" />
            <h3>Permissions Justification</h3>
          </div>

          <div className="permissions-list">
            <div className="permission-item" data-aos="fade-right">
              <span className="permission-name">&lt;all_urls&gt;:</span>
              <span className="permission-desc">Required to detect research papers across academic websites</span>
            </div>
            <div className="permission-item" data-aos="fade-right" data-aos-delay="100">
              <span className="permission-desc">Required for authentication and library management</span>
            </div>
            <div className="permission-item" data-aos="fade-right" data-aos-delay="200">
              <span className="permission-name">dlmscloud.io:</span>
              <span className="permission-desc">Required for OAuth redirect flow</span>
            </div>
            <div className="permission-item" data-aos="fade-right" data-aos-delay="300">
              <span className="permission-name">storage:</span>
              <span className="permission-desc">Required to save user authentication state locally</span>
            </div>
          </div>
        </section>

        {/* No Data Sharing */}
        <section className="info-section highlight-section" data-aos="fade-up">
          <div className="section-header">
            <FontAwesomeIcon icon={faShieldAlt} className="section-icon" />
            <h3>No Data Sharing</h3>
          </div>

          <div className="highlight-grid">
            <div className="highlight-item" data-aos="flip-left">
              <FontAwesomeIcon icon={faCheckCircle} />
              <p>No third-party data sharing</p>
            </div>
            <div className="highlight-item" data-aos="flip-left" data-aos-delay="100">
              <FontAwesomeIcon icon={faCheckCircle} />
              <p>No advertising or tracking</p>
            </div>
            <div className="highlight-item" data-aos="flip-left" data-aos-delay="200">
              <FontAwesomeIcon icon={faCheckCircle} />
              <p>No analytics collection</p>
            </div>
            <div className="highlight-item" data-aos="flip-left" data-aos-delay="300">
              <FontAwesomeIcon icon={faCheckCircle} />
              <p>Data used solely for extension functionality</p>
            </div>
          </div>
        </section>

        {/* User Control */}
        <section className="info-section" data-aos="fade-up">
          <div className="section-header">
            <FontAwesomeIcon icon={faUserShield} className="section-icon" />
            <h3>User Control</h3>
          </div>

          <div className="control-list">
            <div className="control-item" data-aos="fade-up">
              <FontAwesomeIcon icon={faCheckCircle} className="control-icon" />
              <p>Clear logout removes all local data</p>
            </div>
            <div className="control-item" data-aos="fade-up" data-aos-delay="100">
              <FontAwesomeIcon icon={faCheckCircle} className="control-icon" />
              <p>Users choose which papers to import</p>
            </div>
            <div className="control-item" data-aos="fade-up" data-aos-delay="200">
              <FontAwesomeIcon icon={faCheckCircle} className="control-icon" />
              <p>No automatic data collection without user action</p>
            </div>
            <div className="control-item" data-aos="fade-up" data-aos-delay="300">
              <FontAwesomeIcon icon={faCheckCircle} className="control-icon" />
              <p>Transparent data usage explained in popup interface</p>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="contact-section" data-aos="fade-up">
          <div className="contact-card">
            <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
            <h3>Contact</h3>
            <p>For privacy concerns, users can contact:</p>
            <a href="mailto:demo@dlmscloud.com" className="contact-email">
              demo@dlmscloud.com
            </a>
          </div>
        </section>
      </div>
    </div>
  );
}

export default ImporterExtension;